module.exports = __webpack_public_path__ + "static/media/logo-big.bfc4707a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/images/logo-big.jpg
// module id = 216
// module chunks = 0